<div class="w-full text-left">
  <!-- Loading skeleton -->
  <ng-container *ngIf="isLoading()">
    <div class="-mx-4 -mt-5 h-48 skeleton rounded-b-[2rem]"></div>
    <div class="relative z-10 -mt-8 space-y-3">
      <div class="detail-card bg-white rounded-2xl p-5 space-y-2.5">
        <div class="h-4 w-2/3 rounded skeleton"></div>
        <div class="h-3 w-full rounded skeleton"></div>
        <div class="h-3 w-4/5 rounded skeleton"></div>
      </div>
      <div class="detail-card bg-white rounded-2xl p-4 space-y-2">
        <div class="h-3 w-full rounded skeleton"></div>
        <div class="h-3 w-5/6 rounded skeleton"></div>
        <div class="h-3 w-2/3 rounded skeleton"></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="notFound() && !isLoading()">
    <app-manual-hero eyebrow="คู่มือการใช้งาน" title="ไม่พบคู่มือนี้" subtitle="คู่มืออาจถูกปิดการเผยแพร่ หรือลิงก์ไม่ถูกต้อง"></app-manual-hero>
    <div class="relative z-10 -mt-7 detail-card bg-white rounded-2xl p-8 text-center">
      <div class="w-14 h-14 rounded-2xl bg-amber-50 border border-amber-100 flex items-center justify-center mx-auto mb-3">
        <img src="/icons/help_slate.svg" alt="" class="w-7 h-7" />
      </div>
      <a
        routerLink="/manual"
        class="inline-flex items-center justify-center px-5 h-10 rounded-xl bg-(--main-color) text-slate-900 text-xs font-bold no-underline"
      >
        กลับศูนย์ช่วยเหลือ
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="detail() as d">
    <ng-container *ngIf="!isLoading()">
      <button
        *ngIf="d.coverImage; else noCover"
        type="button"
        (click)="openZoom(d.coverImage)"
        class="zoom-media -mx-4 -mt-5 w-[calc(100%+2rem)] max-w-none rounded-b-[2rem] overflow-hidden border-0 p-0 cursor-zoom-in relative bg-slate-200"
      >
        <img [src]="d.coverImage" [alt]="d.titleTh" class="w-full h-52 object-cover" />
        <span class="zoom-hint zoom-hint--top" aria-hidden="true">
          <img src="/icons/search_slate.svg" alt="" class="w-3.5 h-3.5 invert" />
        </span>
      </button>
      <ng-template #noCover>
        <div class="-mx-4 -mt-5 h-24 bg-(--header-background) rounded-b-[2rem] relative overflow-hidden">
          <div class="absolute -right-9 -top-5 w-[120px] h-[120px] rounded-full bg-[rgba(255,197,39,0.12)]"></div>
        </div>
      </ng-template>

      <div class="relative z-10 -mt-8 space-y-3">
        <section class="detail-card bg-white rounded-2xl p-5">
          <span class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-amber-50 border border-amber-100 text-[11px] font-bold text-amber-700">
            {{ kindLabel() }}
          </span>
          <h1 class="text-lg font-extrabold text-slate-800 leading-snug m-0 mt-2">{{ d.titleTh }}</h1>
          <p *ngIf="d.summaryTh" class="text-sm text-slate-500 leading-relaxed m-0 mt-1.5">{{ d.summaryTh }}</p>
        </section>

        <section *ngFor="let block of d.blocks" class="detail-card bg-white rounded-2xl p-4">
          <ng-container [ngSwitch]="block.blockType">
            <p
              *ngSwitchCase="'text'"
              class="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed m-0 pl-3 border-l-[3px] border-(--main-color)"
            >
              {{ block.bodyTh }}
            </p>

            <div *ngSwitchCase="'image'" class="space-y-2">
              <button
                *ngIf="block.image"
                type="button"
                (click)="openZoom(block.image)"
                class="zoom-media w-full rounded-xl overflow-hidden border-0 p-0 cursor-zoom-in bg-slate-50 relative"
              >
                <img [src]="block.image" [alt]="block.bodyTh || ''" class="w-full object-contain max-h-80" />
                <span class="zoom-hint" aria-hidden="true">
                  <img src="/icons/search_slate.svg" alt="" class="w-3.5 h-3.5 invert" />
                </span>
              </button>
              <p *ngIf="block.bodyTh" class="text-xs text-slate-500 font-medium m-0">{{ block.bodyTh }}</p>
            </div>

            <div *ngSwitchCase="'youtube'" class="space-y-2">
              <p *ngIf="block.bodyTh" class="text-sm font-bold text-slate-700 m-0">{{ block.bodyTh }}</p>
              <div
                *ngIf="youtubeEmbedUrl(block.youtubeVideoId) as src"
                class="relative w-full overflow-hidden rounded-xl bg-black aspect-video"
              >
                <iframe
                  [src]="src"
                  class="absolute inset-0 w-full h-full border-0"
                  title="YouTube"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </ng-container>
        </section>

        <a
          [routerLink]="['/manual/guides', kind()]"
          class="flex items-center justify-center gap-1.5 h-11 rounded-xl bg-white border border-slate-200 text-xs font-bold text-slate-600 no-underline"
        >
          ดูหัวข้ออื่นใน{{ kindLabel() }}
          <img src="/icons/chevron_right_slate.svg" alt="" class="w-4 h-4 opacity-60" />
        </a>
      </div>
    </ng-container>
  </ng-container>
</div>

<app-image-viewer
  *ngIf="isViewerOpen()"
  [images]="viewerImages()"
  [startIndex]="viewerIndex()"
  (closed)="closeZoom()"
></app-image-viewer>
